"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vesting__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "planId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lockPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "vestingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "initialUnlockPercent",
                type: "uint256",
            },
        ],
        name: "AddVestingPlan",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lockPeriod",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_vestingPeriod",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_initialUnlockPercent",
                type: "uint256",
            },
        ],
        name: "addVestingPlan",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_planId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_allocation",
                type: "uint256",
            },
        ],
        name: "allocateVesting",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allocations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "planId",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "addrs",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_allocations",
                type: "uint256[]",
            },
        ],
        name: "batchAllocateVesting",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "claimableAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "claimed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "depositByAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "plans",
        outputs: [
            {
                internalType: "uint256",
                name: "lockPeriod",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "vestingPeriod",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "initialUnlockPercent",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_vestingStartDate",
                type: "uint256",
            },
        ],
        name: "startVesting",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalClaimed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "userPlanId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vestingStartDate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawAllByAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Vesting__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "Vesting";
    }
    deploy(_token, overrides) {
        return super.deploy(_token, overrides || {});
    }
    getDeployTransaction(_token, overrides) {
        return super.getDeployTransaction(_token, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Vesting__factory = Vesting__factory;
Vesting__factory.bytecode = _bytecode;
Vesting__factory.abi = _abi;
